//*react- recursos

import { useEffect, useState } from "react";

//*archivos

//*interfaces
    interface PropsAPI {
        myAPI: any;
    }
  
//*componente
  export default function CargaAPI(props: PropsAPI) {
   const mensaje = document.getElementById('verMsj');

    //**rutina directa 
    /*
      async function obtenerData(){
        await fetch( props.myAPI )
        .then (response => response.json())
        .then (json => console.log(json))
        .catch (error => console.log('Solicitud fallida', error))
    }

    obtenerData(); */

    //**rutina con useEffect y useState
    const [data, setData]= useState([]);
    const [msj, setMsj]= useState('xx');
    //const [mensaje, setMensaje]= useState(document.getElementById('verMsj'));
    useEffect(()=> {
        const obtenerData = async () => {
            const response = await fetch(props.myAPI);
            const data = await response.json();
            //let m = mensaje?.DOCUMENT_NODE.
            console.log('mensaje:::::', mensaje);
            //console.log('m:', m)

            setData(data);
            if (data.length == 0)
                 setMsj("base de datos cargada con " + data.lenght + "elementos")
                 //console.log('data:' , data);
            else 
                 setMsj("base de datos vacía ")
                 //console.log('Arreglo vacío'); 
           //mensaje?.innerText==msj;   
                     
        };
      
        obtenerData().catch(error => console.log('Solicitud fallida', error));
       
    }, [])
    
   //mensaje?.innerText=msj;
    //*vista
    return (
         < >
              <label className="container">
                Aquí se genera un elemento con la carga de un API fijo, ver respuesta con F12 en consola <br/>
              </label>
             {/*  <p id="verMsj">-------</p> */}
         </>
      )
  }
  